export const qualClass = (q) => {
  const approved = ["Qualified", "Approved for Referral", "Enrolled"];
  const warn = ["Conditionally Qualified", "Pending Review", "Under Review"];
  const bad = ["Disqualified", "Not Yet Qualified", "Not Moving Forward", "Closed"];
  if (approved.includes(q)) return "bg-magenta-light text-magenta border border-magenta/20";
  if (bad.includes(q)) return "bg-red-50 text-red-700 border border-red-200";
  if (warn.includes(q)) return "bg-navy-light text-navy border border-navy/20";
  return "bg-navy-light text-navy border border-navy/20";
};

export const Badge = ({ children, className = "" }) => (
  <span className={`inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${className}`}>
    {children}
  </span>
);
